import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { APPOINTMENT_TABS, VIEW_KEYS } from '../constants';
import { useAppointmentAnalyticsV2ShallowStore } from '../hooks/use-appointment-analytics-v2-store';
import { ViewRendererProps } from '../types';
import { AppointmentBreakdownChart } from './past-appointments/appointment-breakdown-chart';
import { KPICards } from './past-appointments/kpi-cards';
import { NoShowRateChart } from './past-appointments/no-show-rate-chart';
import { TopBanner } from './past-appointments/top-banner';
import { ScheduleRequestsChart } from './schedule-requests-chart';
import { AppointmentAnalyticsV2TableView } from './views/table-view';

export const PastAppointmentsTab = (props: ViewRendererProps) => {
  const { aggregatesData, aggregatesDataLoading, containerStyles } = props;
  const { view } = useAppointmentAnalyticsV2ShallowStore('view');

  return (
    <div css={styles.tabContent} style={containerStyles}>
      {view === VIEW_KEYS.TABLE ? (
        <AppointmentAnalyticsV2TableView />
      ) : (
        <>
          <TopBanner aggregatesData={aggregatesData} aggregatesDataLoading={aggregatesDataLoading} />
          <KPICards aggregatesData={aggregatesData} aggregatesDataLoading={aggregatesDataLoading} />
          <AppointmentBreakdownChart aggregatesData={aggregatesData} aggregatesDataLoading={aggregatesDataLoading} />
          <NoShowRateChart />
          <ScheduleRequestsChart tab={APPOINTMENT_TABS.PAST} />
        </>
      )}
    </div>
  );
};

const styles = {
  tabContent: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};
  `,
};
